import React from "react";
import "./Toggle.css";

const ToggleButton = (props) => {
  return (
    <label className="switch">
      {props.theme!=="light"?<input type="checkbox" onChange={props.switchTheme}/>:<input type="checkbox" onChange={props.switchTheme} checked/>}
      <span className="slider"></span>
    </label>
  );
};

export default ToggleButton;
